<template>
  <div class="tag-search-input">
    <b-autocomplete
        ref="autocomplete"
        v-model="query"
        icon="search"
        :placeholder="placeholder"
        :keep-first="true"
        :open-on-focus="true"
        :clear-on-select="true"
        :data="filteredOptions"
        role="combobox"
        :aria-expanded="isDropDownOpen ? 'true' : 'false'"
        aria-controls="ingredient-options"
        :aria-activedescendant="selectedIndex !== -1 ? 'option-' + selectedIndex : null"
        aria-autocomplete="both"
        :aria-label="ariaLabel"
        field="label"
        @focus="checkHover"
        @blur="onCloseDropDown"
        @keyup.up.native="checkHover"
        @keyup.down.native="checkHover"
        @select="addSelection">
      <template slot-scope="props">
        <span
            :id="'option-' + props.index"
            role="option"
            :aria-selected="props.index === selectedIndex"
            @mouseenter="highlightOption(props.index)"
            aria-live="polite">
          {{ props.option.value }}
        </span>
      </template>
      <template slot="empty">{{ emptyMessage }}</template>
    </b-autocomplete>


    <transition-group name="tags" tag="div" class="tags are-small">
			<span class="tag is-black" v-for="selection in selections" :key="selection.value" aria-selected="true">
				{{ selection.label }}
				<a class="delete is-small" role="option" tabindex="0" :aria-label="`Remove ${selection.value}`" @keypress.enter="removeSelection(selection)" @click="removeSelection(selection)"></a>
			</span>
    </transition-group>
  </div>
</template>

<script>
import OnDemandLiveRegion from "on-demand-live-region";
import debounce from "lodash.debounce";

export default {
  name: "TagSearchInput",

  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    options: {
      type: Array,
      default: () => ([])
    },
    placeholder: {
      type: String,
      default: "Search"
    },
    ariaLabel: {
      type: String,
      default: "Search"
    }
  },

  data() {
    return {
      query: "",
      selections: [],
      isDropDownOpen: false,
      selectedIndex: -1,
    };
  },

  computed: {
    filteredOptions() {
      return this.options.filter((option) => {
        return option.label.toLowerCase().indexOf(this.query.toLowerCase()) >= 0 &&
            this.selections.findIndex(s => s.value === option.value) == -1 &&
            (!option.hasOwnProperty("count") || (option.hasOwnProperty("count") && option.count > 0));
      });
    },

    emptyMessage() {
      return this.query.length > 0 ? `No results for ${this.query}` : "No results";
    }
  },

  methods: {
    addSelection(selection, event) {
      //to maintain accessibility, do not select if user is tabbing through
      if (selection && !(event.key === 'Tab')) {
        this.selections.push(selection);
        this.emitSelections();
      }
    },

    checkHover(event) {
      debounce(_ => {
        Array.from(document.getElementsByClassName("dropdown-item is-hovered")).forEach(next => {
          let optionItem = next?.children[0]?.id
          this.selectedIndex = parseInt(optionItem.split('-')[1])
          new OnDemandLiveRegion().say(next.textContent);
        })
        this.isDropDownOpen = true
      }, 300)();
    },

    onCloseDropDown(event) {
      debounce(_ => {
        this.isDropDownOpen = false
        this.selectedIndex = -1
      }, 300)();
    },

    removeSelection(selection) {
      if (selection) {
        const index = this.selections.findIndex(s => s.value === selection.value);
        if (index >= 0) {
          this.selections.splice(index, 1);
          this.emitSelections();
        }
      }
    },

    emitSelections() {
      const values = this.selections.map(s => s.value);
      this.$emit("input", values);
    },

    clear() {
      this.selections = [];
    },

    addAttributeToDropdown() {
      this.$nextTick(() => {
        const dropdown = document.querySelector('.dropdown-menu')

        if (dropdown) {
          dropdown.setAttribute('role', 'listbox') // Add custom attribute
          dropdown.setAttribute('id', 'ingredient-options')
        }
      })
    },

    highlightOption(index){
      this.selectedIndex = index
    }
  },

  mounted() {
    this.addAttributeToDropdown()
    // Pre-select stuff
    this.value.forEach(value => {
      const index = this.options.findIndex(o => o.value === value);
      if (index > -1) {
        this.selections.push(this.options[index]);
      }
    });

  }
}
</script>
